import { render, staticRenderFns } from "./footerComp.vue?vue&type=template&id=432629a0&scoped=true"
import script from "./footerComp.vue?vue&type=script&lang=js"
export * from "./footerComp.vue?vue&type=script&lang=js"
import style0 from "./footerComp.vue?vue&type=style&index=0&id=432629a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432629a0",
  null
  
)

export default component.exports